import { IconSend } from '@tabler/icons-react'

export const PERMISSION_SETS_REFERRALS = {
  id: 'Referrals',
  description: 'Grant access to send data-sharing requests.',
  icon: IconSend,
}
